<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>

                <v-row class="px-4 pt-4" style="align-items: center;">
                    <span>
                        <h3>Update claim {{ claim }}</h3>
                    </span>
                    <span class="ml-4" style="color: #1976d2; background-color: rgba(25, 118, 210, 0.1); border: 1px solid #1976d2; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
                        <v-icon color="#1976d2" size="18" class="mr-2">mdi-information</v-icon>{{ claim_description }}
                    </span>
                    <v-spacer></v-spacer>

                    <span class="ml-6 mt-1">
                        <attm_button :attachments="attachments" :encrid="hosm_encrid" entity="hosm" :entitykey="claim" @updateData="updateAttachments" />
                    </span>
                    <span class="ml-6 mt-1">
                        <mail_button :mails="mails" :encrid="hosm_encrid" @showDialog="showMailDialog" />
                    </span>
                </v-row>
                <v-row dense class="px-2">
                    <span style="font-size: small;">
                        Duration <b>{{ hosm_normal_days }}</b> days, business days <b>{{ hosm_business_days }}</b>
                    </span>
                </v-row>
                <v-row><v-divider></v-divider></v-row>
                <v-row class="pl-4 mt-6">
                    <vat_headers :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="mt-6 mb-6"><v-divider></v-divider></v-row>

                <selections :reportedby="reportedby" :hosm_gebr="hosm_gebr" :claim_ins="claim_ins" :hosm_smct_sel="hosm_smct_sel"
                            :customerInformed="customerInformed" :customerLiable="customerLiable" :depositPaid="depositPaid" @updateData="updateData"/>

                <v-card fluid flat class="mt-3">
                    <hokl_hosm_components title="Claim components" :components="components" @updateData="updateData" />
                </v-card>

                <v-row>
                    <v-col cols="12" class="pr-6">
                        <v-textarea v-model="hosm_memo" rows="4" label="Internal memo">{{ hosm_memo }}</v-textarea>
                    </v-col>
                </v-row>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small v-on:click="updHosm()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
                </v-card-actions>

                <mails_dialog ref="mailDialog" :width="'49%'" />

            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>

    import vat_headers from '@/components/huov/hosm/vat_header.vue'
    import mail_button from '@/components/ui/buttons/btn_mails.vue'
    import mails_dialog from '@/components/huov/hosm/showMails.vue'
    import attm_button from '@/components/huov/ui/attm_button.vue'
    import hokl_hosm_components from '@/components/huov/ui/hokl_hosm_components.vue';
    import selections from '@/components/huov/hosm/ui/screen_selections.vue';

    export default {
        props: {
            huov_encrid: String,
            claim_description: String
        },
        components:{
            attm_button,
            vat_headers,
            mail_button,
            mails_dialog,   
            hokl_hosm_components,
            selections
        },
        data() {
            return {
                dialog: false,
                hosm_encrid: null,
                gebr_code:'',
                hosm_gebr:'',    
                hosm_memo:'',
                hosm_business_days: 0,
                hosm_normal_days: 0,
                claim:'',
                claim_opened:'',
                attachments:0,
                mails:0,
                hosm_smct_sel: [],
                reportedby: '',
                claim_ins: '',
                customerInformed: false,
                customerLiable: false,
                depositPaid: false,    
                components:[], // start with 1 empty record
            }
        }, 
        methods: {
            open(hosm_encrid, claim, claim_opened) {
                console.log(claim);
                this.hosm_encrid = hosm_encrid;
                this.hosm_memo = '';
                this.attachments = 0;
                this.mails = 0;
                this.hosm_smct_sel = [];
                this.claim = claim;
                this.claim_ins = '';
                this.customerInformed = false,
                this.hosm_business_days = 0;
                this.hosm_normal_days = 0;                
                this.customerLiable = false,
                this.depositPaid = false,                    
                this.claim_opened = claim_opened;
                this.components = [{key: 0, description: '', amount: ''}]; // start with 1 empty record

                this.getSingleHosm();
            },
            closeDialog(){
                this.$emit('updateData', 'refresh');
                this.dialog = false;
            },
            showMailDialog(encrid){
                console.log('show mail dialog', encrid);
                this.$refs.mailDialog.open(encrid);
            },
            updateData(data){
                console.log('component: updateData', data);
                this[data.field] = data.value;
            },		
            updateAttachments(){
                console.log('component: updateAttachments');
                this.getSingleHosm();
            },
            getSingleHosm(){
                console.log('encrid', this.hosm_encrid);
                this.$axios
                    .post("ares/json/ares/huov/hosm/getSingleHosm.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getSingleHosm"
                        },
                        getSingleHosm: {
                            hosm_encrid: this.hosm_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                            this.dialog = false; // do not show dialog
                        } else {
                            console.log(res.data.getSingleHosm, res.data.getSingleHosm.depositPaid);
                            this.hosm_smct_sel = res.data.getSingleHosm.selected_smct;
                            this.hosm_gebr = res.data.getSingleHosm.gebr_code;
                            this.hosm_memo = res.data.getSingleHosm.hosm_memo;
                            this.attachments = res.data.getSingleHosm.attachments;
                            this.mails = res.data.getSingleHosm.mails;
                            this.reportedby = res.data.getSingleHosm.reportedby;
                            this.customerInformed = res.data.getSingleHosm.customerInformed;
                            this.customerLiable = res.data.getSingleHosm.customerLiable;
                            this.depositPaid = res.data.getSingleHosm.depositPaid;
                            this.components = res.data.getSingleHosm.components;
                            this.claim_ins = res.data.getSingleHosm.claim_ins;          
                            this.hosm_business_days =  res.data.getSingleHosm.hosm_business_days;
                            this.hosm_normal_days =  res.data.getSingleHosm.hosm_normal_days;
                            this.dialog = true;
                            this.loading = false;    
                        }
                    });   
            },  
            updHosm(){
                this.$axios
                .post("ares/json/ares/huov/hosm/updHosmv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHosm"
                    },
                    updHosm: {            
                        hosm_encrid: this.hosm_encrid,
                        hsmr_smst: this.hsmr_smst,
                        hosm_memo: this.hosm_memo,
                        hosm_gebr: this.hosm_gebr,
                        claimedAmount: this.totCompAmount,
                        paidAmount: '',
                        leniencyAmount: '',
                        selected_smct: this.hosm_smct_sel,
                        reportedby: this.reportedby,
                        customerInformed: this.customerInformed,
                        customerLiable: this.customerLiable,
                        depositPaid: this.depositPaid,       
                        components: this.components,       
                        claim_ins: this.claim_ins,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log('component', res.data.error);
                        // laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
                    }  else { 
                        this.closeDialog();
                    }
                });
            }  
        }
    }
</script>

<style scoped>
</style>
